var _excluded = ["storageID", "children"];

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import h from "@macrostrat/hyper";
import { createContext, useState, useContext } from "react";
import update from "immutability-helper";
import { LocalStorage } from "../util/local-storage";

// Could rework this to use `constate` or similar
function createSettingsContext(defaultValue) {
  /** Function that creates a context with an updateable settings object
   */
  var Context = /*#__PURE__*/createContext(defaultValue);
  var UpdateContext = /*#__PURE__*/createContext(null);

  var Provider = function Provider(props) {
    /*
    A settings provider that can be used with LocalStorage
    */
    var storageID = props.storageID,
        children = props.children,
        defaultSettings = _objectWithoutProperties(props, _excluded); // Update from local storage


    var storage = null;
    console.log("Setting up SettingsProvider [ui-components]");

    if (storageID != null) {
      // Merge initial options if set
      storage = new LocalStorage(storageID);
      var v = storage.get() || {};
      console.log("Loading from local storage", v); // @ts-ignore

      defaultSettings = update(defaultSettings, {
        $merge: v
      });
    } // @ts-ignore


    var _useState = useState(defaultSettings),
        _useState2 = _slicedToArray(_useState, 2),
        settings = _useState2[0],
        setState = _useState2[1];

    var updateState = function updateState(spec) {
      var newSettings = update(settings, spec);
      setState(newSettings);

      if (storage != null) {
        return storage.set(newSettings);
      }
    };

    return h(Context.Provider, {
      value: settings
    }, [h(UpdateContext.Provider, {
      value: updateState
    }, children)]);
  };

  var useValue = function useValue() {
    return useContext(Context);
  };

  var useUpdater = function useUpdater(key) {
    var updater = useContext(UpdateContext);
    if (key == null) return updater; //@ts-ignore

    return function (spec) {
      return updater(_defineProperty({}, key, spec));
    };
  };

  return [Provider, useValue, useUpdater];
}

var _createSettingsContex = createSettingsContext({}),
    _createSettingsContex2 = _slicedToArray(_createSettingsContex, 3),
    SettingsProvider = _createSettingsContex2[0],
    useSettings = _createSettingsContex2[1],
    useSettingsUpdater = _createSettingsContex2[2]; // Deprecated: this is kind of confusing


var updateSettings = function updateSettings(func) {
  // Update settings using `immutability-helper` semantics
  //@ts-ignore
  var updater = useSettingsUpdater();
  return function () {
    //@ts-ignore
    return updater(func.apply(void 0, arguments));
  };
};

export { SettingsProvider, useSettings, updateSettings, createSettingsContext };